<template>
  <div class="nav-accordion" data-track-as="nav-accordion">
    <slot></slot>
  </div>
</template>

<script>
import NavCollapsible from './NavCollapsible'

export default {
  name: 'NavAccordion',
  components: {
    /* eslint-disable-next-line */
    NavCollapsible,
  },
}
</script>

<style lang="postcss" scoped>
.nav-accordion {
  border-top: 1px solid var(--c-secondary-neutral-3);
}

@media (--lg) {
  .nav-accordion {
    display: flex;
    gap: var(--spacing-16) var(--spacing-8);
    flex-wrap: wrap;
    border-top: none;
  }
}
</style>
